export const calcularCuotas = ({meta, tasaMensual, meses}) =>{
// Convertir porcentaje a decimal (ej: 1% -> 0.01)
    const i = tasaMensual / 100;

    // Aplicar la fórmula de valor futuro de una anualidad
    const cuota = (meta * i) / (Math.pow(1 + i, meses) - 1);

    return cuota.toFixed(0);
}